import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FAQSection: React.FC = () => {
  const faqs = [
    {
      question: "How much life insurance do I need?",
      answer: "The amount varies by individual, but a common rule of thumb is 8-12 times your annual income. Our calculator can help you determine the exact amount based on your debts, dependents, and financial goals. Consider factors like mortgage balance, children's education costs, and your family's lifestyle needs."
    },
    {
      question: "Is this a real quote?",
      answer: "Yes! Our quotes are real estimates based on current rates from our partner insurance carriers. However, final rates may vary slightly based on your medical exam and detailed application review. We work with A+ rated carriers to ensure you're getting legitimate, competitive quotes."
    },
    {
      question: "Do I need a medical exam?",
      answer: "It depends on your age, coverage amount, and health status. Many carriers offer no-exam policies up to certain coverage limits (typically $250K-$500K). Our AI will match you with carriers that offer no-exam options if that's important to you. No-exam policies are often approved faster but may have slightly higher premiums."
    },
    {
      question: "Is Safurra licensed?",
      answer: "Yes, Safurra is a licensed insurance agency. We're authorized to sell life insurance in all 50 states and work only with A+ rated, financially stable insurance carriers. Our licensing information is available upon request, and we maintain all required professional certifications."
    },
    {
      question: "How are your insurance partners selected?",
      answer: "We partner exclusively with insurance carriers that have A+ ratings from major rating agencies (A.M. Best, Moody's, S&P). We evaluate carriers based on financial stability, customer service ratings, claims paying ability, and competitive pricing. Our goal is to offer you choices from the most reliable companies in the industry."
    },
    {
      question: "How long does the application process take?",
      answer: "The process varies by carrier and coverage amount. No-exam policies can be approved in 24-48 hours. Traditional policies requiring a medical exam typically take 2-6 weeks. We'll guide you through each step and keep you updated on your application status."
    },
    {
      question: "Can I change my policy later?",
      answer: "Yes, most life insurance policies offer flexibility. You can often increase coverage (subject to underwriting), add riders, change beneficiaries, and adjust payment schedules. Term policies can usually be converted to permanent coverage within a certain timeframe without a medical exam."
    },
    {
      question: "What if I have health issues?",
      answer: "Having health issues doesn't automatically disqualify you from coverage. Many carriers specialize in covering people with various health conditions. Our AI matching system considers your health status and connects you with carriers most likely to approve your application at competitive rates."
    },
    {
      question: "How much does life insurance cost?",
      answer: "Costs vary widely based on age, health, coverage amount, and policy type. A healthy 30-year-old might pay $20-40/month for $500K in term coverage, while a 50-year-old might pay $100-200/month for the same coverage. Our quotes are personalized to your specific situation."
    },
    {
      question: "What happens after I get a quote?",
      answer: "After receiving your quote, you can apply directly with the carrier through their secure application. You'll complete a detailed health questionnaire and potentially schedule a medical exam. We'll help guide you through the process and answer any questions along the way."
    }
  ];

  return (
    <div className="w-full">
      <Accordion type="single" collapsible className="space-y-4">
        {faqs.map((faq, index) => (
          <AccordionItem 
            key={index} 
            value={`item-${index}`}
            className="border border-border rounded-lg px-6"
          >
            <AccordionTrigger className="text-left font-medium text-foreground hover:text-primary transition-colors py-4">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pb-4">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};